// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../src/store/index';
// AOS动画效果
import AOS from 'aos'
import 'aos/dist/aos.css'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// import '@/styles/index.scss' // global css
import '../src/assets/stylus/index.styl';
import '../src/assets/stylus/color.styl';
import component from '@/common/component';
// import 'font-awesome/css/font-awesome.css';
// vue 开关组件
// vue 拖拽组件
import vuedraggable from 'vuedraggable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueDraggableResizable from 'vue-draggable-resizable'
// ueditor组件
import '../static/plugins/ueditor/ueditor.config.js';
import '../static/plugins/ueditor/ueditor.all.js';
import '../static/plugins/ueditor/lang/zh-cn/zh-cn.js';
import '../static/plugins/ueditor/ueditor.parse.min.js';
// 按需引入Echarts
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/line'
// 图片裁剪
import VueCropper from 'vue-cropper'

require('es6-promise').polyfill()
Vue.component('chart', ECharts);
Vue.component('vuedraggable', vuedraggable);
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = false
Vue.use(Element);
Vue.use(component);
Vue.use(vuedraggable);
Vue.use(VueCropper)
/* eslint-disable no-new */
AOS.init();
new Vue({
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js